import {remCalc} from '../_utils'

const sizes = {
    button: {
        small: {
            paddingY: remCalc(6),
            paddingX: remCalc(8),
            height: 'fit-content',
        },
        base: {
            paddingY: remCalc(8),
            paddingX: remCalc(12),
            height: remCalc(32),
        },
        large: {
            paddingY: remCalc(12),
            paddingX: remCalc(16),
            height: remCalc(36),
        },
        xl: {
            paddingY: remCalc(12),
            paddingX: remCalc(24),
            height: remCalc(44),
        },
    },

    input: {
        small: {
            paddingX: remCalc(6),
            paddingY: remCalc(4),
            height: remCalc(32),
        },
        base: {
            paddingX: remCalc(6),
            paddingY: remCalc(6),
            height: remCalc(36),
        },
        large: {
            paddingX: remCalc(8),
            paddingY: remCalc(8),
            height: remCalc(40),
        },
        xl: {
            paddingX: remCalc(12),
            paddingY: remCalc(8),
            height: remCalc(44),
        },
    },
}

export default sizes
